import { ACCOUNTSLUG_STATUSES } from 'appconstants';

export default value => {
  if (value === 'LINKED') {
    return ACCOUNTSLUG_STATUSES.LINKED;
  } if (value === 'UNLINKED') {
    return ACCOUNTSLUG_STATUSES.UNLINKED;
  } return ACCOUNTSLUG_STATUSES.UNLINKED;
};
